import cardAs from './card_as';
export var CardLink = cardAs('a', true);
export var CardButton = cardAs('button', true);
export var CardLabel = cardAs('label', true);
export default cardAs('div');
export { cardAs };
export { default as CardGroup } from './card_group';